import React, { useRef, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import _ from 'lodash';
import moment from 'moment';
import * as taxApi from '../../../lib/api/taxbill';

import { useFormik, FormikProvider } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
//mui
import { Box, Button, Divider, Typography } from '@mui/material';

import AskDialog from '../../../components/common/dialog/AskDialog';
import SalesBillFormList from '../../../components/projectmng/bill_mng/SalesBillFormList';

import {
  listProjectBuyTaxbills,
  listProjectInitSalesTaxbills,
  listProjectSalesTaxbills,
  listProjectInitSalesTaxbillsPlan,
} from '../../../modules/projectModule/issue-taxbills';
import InvoiceLinModalConatiner from '../../common/form/modal/InvoiceLineModalContainer';
import { listInvoiceApprovalLine } from '../../../modules/empModule/empApproval';

//-----------------------------------------------------

//-----------------------------------------------------

const SalesBillFormContainer = ({ project, issueNo }) => {
  const dispatch = useDispatch();
  const arrayHelperRef = useRef();
  const { enqueueSnackbar } = useSnackbar();

  const [apprUuid, setApprUuid] = useState(null);
  const { initSalesTaxbills, invoiceLines } = useSelector(
    ({ projectModule, empModule }) => ({
      invoiceLines: empModule.employeeApproval.invoiceLines,
      initSalesTaxbills: projectModule.issueTaxbills.initSalesTaxbills,
    }),
  );

  const [visible, setVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const handleClose = () => {
    setOpenModal(false);
  };
  const onCancle = () => {
    setVisible(false);
  };

  const [initialValues, setInitialValues] = useState({ purchaseBills: [] });

  useEffect(() => {
    if (project) {
      //getInitTaxbills(project.prjUuid);
      dispatch(listProjectInitSalesTaxbills(project.prjUuid));
    }
  }, [project]);

  useEffect(() => {
    if (initSalesTaxbills) {
      setInitialValues({ purchaseBills: initSalesTaxbills });
    }
  }, [initSalesTaxbills]);

  useEffect(() => {
    
    if (invoiceLines) {
      setApprUuid(invoiceLines[0]?.apprUuid);
    } else {
      dispatch(listInvoiceApprovalLine());
    }
  }, [invoiceLines]);

  // const getInitTaxbills = async (id) => {
  //   try {
  //     const res = await taxApi.getInitTaxbillByPrj(id, 'S');
  //     if (res.data.list) {
  //       const purchaseBills = res.data.list.map((item) => ({
  //         ...item,
  //         buyDiv: 1,
  //       }));
  //       const changeInit = { purchaseBills };
  //       setInitialValues(changeInit);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  let validationSchema = yup.object({
    purchaseBills: yup.array().of(
      yup.object().shape({
        reqCompDt: yup.string('').required('매입일자를 입력하세요'),
        invTxt: yup.string('').required('매입내용을 입력하세요'),
        invAmt: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('매입금액을 입력하세요')
          .min(0, '최소 0 이상을 입력하세요'),
        invVat: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('부가세를 입력하세요')
          .min(0, '최소 0 이상을 입력하세요'),
        prodCompDt: yup.string('').required('지급예정일자를 입력하세요'),
        buyDiv: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('매입횟수 입력하세요')
          .min(1, '최소 1 이상을 입력하세요')
          .max(24, '최대 24 이하만 가능합니다'),
      }),
    ),
  });
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setOpenModal(true);
    },
  });

  const [message, setMessage] = useState('');

  const checkValidation = () => {
    let valid = true;

    if (apprUuid === '' || apprUuid === null) {
      valid = false;
      setMessage('결재선을 선택하세요.');
      return valid;
    }

    //원가산출 체크
    const findItem = formik.values.purchaseBills.find((item) => {
      if (item?.osTran !== 'Y') {
        const perVat = (Number(item?.invVat) / Number(item?.invAmt)) * 100;

        //부가세가 9% 미만 12% 초과
        if (perVat < 9 || perVat > 12) {
          setMessage(
            '부가세가 매입금액의 9% 미만 또는 12% 초과인 항목이 있습니다.등록폼을 확인하십시오',
          );
          return item;
        }

        if (
          Number(item?.billSumTotal) <
          Number(item?.billIssuedTotal) + Number(item?.invAmt)
        ) {
          setMessage(
            '기매입금액과 매입금액의 합계가 총매입금액을 초과하는 항목이 있습니다. 등록폼을 확인하십시오.',
          );
          return item;
        }
      }
    });

    valid = findItem ? false : true;

    return valid;
  };

  const makeData = (values) => {
    const data = [];
    _.forEach(values, (value) => {
        value.invNoPlan = issueNo;
      if (Number(value?.invAmt) > 0) {
        value.reqCompDt = moment(value.reqCompDt).format('YYYY-MM-DD');
        value.prodCompDt = moment(value.prodCompDt).format('YYYY-MM-DD');
        data.push(value);
      }
    });
    return data;
  };

  const handleSubmit = () => {
    const valid = checkValidation();
    //console.log(valid, 'valid');
    if (!valid) {
      setVisible(true);
      formik.setSubmitting(false);
      return;
    } else {
      //buyVal 0원인건 보내지 않음.
      formik.setSubmitting(true);
      const saveData = {
        type: 'S',
        data: makeData(formik.values.purchaseBills),
        apprUuid: apprUuid,
      };
      onSave(saveData);
      //console.log(JSON.stringify(saveData));
      formik.resetForm();
    }
  };

  const onSave = async (saveData) => {
    try {
      const res = await taxApi.addIssuedTaxbill(project.prjUuid, saveData);
      if (res.data) {
        //redux
        dispatch(listProjectBuyTaxbills(project.prjUuid));
        dispatch(listProjectSalesTaxbills(project.prjUuid));
        dispatch(listProjectInitSalesTaxbills(project.prjUuid));
        dispatch(listProjectInitSalesTaxbillsPlan(project.prjUuid));
        enqueueSnackbar('매출계산서 저장 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  if (initSalesTaxbills && initSalesTaxbills.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="subtitle2">
          발행할 매출 계산서 내역이 없습니다.
        </Typography>
      </Box>
    );
  }

  return (
    <FormikProvider value={formik}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <SalesBillFormList formik={formik} ArrayHelperRef={arrayHelperRef} issueNo={issueNo}/>
        <Divider sx={{ my: 1 }} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button type="submit" variant="outlined">
            발행 요청
          </Button>
        </Box>
        <AskDialog
          visible={visible}
          title="등록 오류"
          description={message}
          onCancle={onCancle}
          onConfirm={onCancle}
        />
        {openModal && (
          <InvoiceLinModalConatiner
            title="결재라인 선택"
            open={openModal}
            approvalLines={invoiceLines}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        )}
      </Box>
    </FormikProvider>
  );
};

export default SalesBillFormContainer;
